import { cn } from '@/lib/utils';

export const FieldLabel = ({
  children,
  optional,
}: {
  children: React.ReactNode;
  optional?: boolean;
}) => (
  <p className="text-xs font-medium uppercase tracking-[0.02em] text-gray-500">
    {children}
    {optional && <OptionalMarker />}
  </p>
);

export const OptionalMarker = () => (
  <span className="font-normal italic normal-case"> (Optionnel)</span>
);

export const FieldHelper = ({
  error,
  children,
}: {
  error?: boolean;
  children?: React.ReactNode;
}) =>
  children ? (
    <p
      role={error ? 'alert' : undefined}
      className={cn(
        'text-2xs font-light',
        error ? 'text-red-600' : 'text-gray-500',
      )}
    >
      {children}
    </p>
  ) : null;
